"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.money = exports.convert = exports.buildFromSimple = exports.simpleExtract = exports.defaultFormatter = exports.splitFormatter = exports.staticFormatter = exports.stringifyFormatter = exports.replaceFormatter = exports.keyFormatter = exports.isDateFormatter = exports.dateFormatter = exports.conditionFormatter = exports.compareFormatter = exports.isFormatter = exports.formatWithKeys = exports.format = exports.getFormattedKeys = exports.getFormattedValues = exports.DEFAULT_CODE_SEPARATOR = void 0;
var moment_1 = __importDefault(require("moment"));
var sprintf_js_1 = require("sprintf-js");
var isEqual_1 = __importDefault(require("lodash/isEqual"));
var range_1 = __importDefault(require("lodash/range"));
var dto_1 = require("remota-common/dto");
var util_1 = require("remota-common/util");
var object_1 = require("./object");
var date_1 = require("./date");
var enum_1 = require("../enum");
exports.DEFAULT_CODE_SEPARATOR = "\x1f";
function getFormattedValues(result) {
    return Array.isArray(result) ? result.map(function (r) { return r.value; }) : result.value;
}
exports.getFormattedValues = getFormattedValues;
function getFormattedKeys(result) {
    return Array.isArray(result) ? result.reduce(function (prev, r) { return prev.concat(r.keys); }, []) : result.keys;
}
exports.getFormattedKeys = getFormattedKeys;
function format(obj, formatter) {
    return getFormattedValues(formatWithKeys(obj, formatter));
}
exports.format = format;
function formatWithKeys(obj, formatter) {
    switch (formatter.type) {
        case dto_1.FormatterType.COMPARE:
            return compareFormat(obj, formatter);
        case dto_1.FormatterType.CONDITION:
            return conditionFormat(obj, formatter);
        case dto_1.FormatterType.DATE:
            return dateFormat(obj, formatter);
        case dto_1.FormatterType.IS_DATE:
            return isDateFormat(obj, formatter);
        case dto_1.FormatterType.KEY:
            return keyFormat(obj, formatter);
        case dto_1.FormatterType.SPLIT:
            return splitFormat(obj, formatter);
        case dto_1.FormatterType.REPLACE:
            return replaceFormat(obj, formatter);
        case dto_1.FormatterType.STRINGIFY:
            return stringifyFormat(obj, formatter);
        case dto_1.FormatterType.STATIC:
            return staticFormat(obj, formatter);
        default: {
            var _1 = formatter;
            throw new Error("Invalid formatter ".concat(formatter));
        }
    }
}
exports.formatWithKeys = formatWithKeys;
function emptyToUndefined(res) {
    function convert(root) {
        return { value: root.value === "" ? undefined : root.value, keys: root.keys };
    }
    return Array.isArray(res) ? res.map(convert) : convert(res);
}
function compareFormat(obj, formatter) {
    var vs = formatter.items.map(function (item) {
        var v = formatWithKeys(obj, item);
        return emptyToUndefined(v);
    });
    var isArray = vs.some(function (v) { return Array.isArray(v); });
    var lens = vs.map(function (v) { return (Array.isArray(v) ? v.length : 1); });
    var maxLen = Math.max.apply(Math, __spreadArray([], __read(lens), false));
    var minLen = Math.min.apply(Math, __spreadArray([], __read(lens), false));
    if (!isArray || minLen === 0) {
        return vs.slice(1).reduce(function (prev, v) {
            var value = isTrue(prev) && (0, isEqual_1.default)(getFormattedValues(vs[0]), getFormattedValues(v));
            return { value: value, keys: [] };
        }, { value: true, keys: [] });
    }
    return (0, range_1.default)(0, maxLen).map(function (i) {
        var v0 = Array.isArray(vs[0]) ? vs[0][i % vs[0].length] : vs[0];
        return vs.slice(1).reduce(function (prev, v) {
            return {
                value: isTrue(prev) && (0, isEqual_1.default)(getFormattedValues(v0), getFormattedValues(Array.isArray(v) ? v[i % v.length] : v)),
                keys: [],
            };
        }, { value: true, keys: [] });
    });
}
function conditionFormat(obj, formatter) {
    var condition = formatWithKeys(obj, formatter.condition);
    if (Array.isArray(condition)) {
        return condition.map(function (cond, i) {
            var value = isTrue(cond) ? formatWithKeys(obj, formatter.caseTrue) : formatWithKeys(obj, formatter.caseFalse);
            return Array.isArray(value) ? value[i % value.length] : value;
        });
    }
    else if (isTrue(condition)) {
        return formatWithKeys(obj, formatter.caseTrue);
    }
    else {
        return formatWithKeys(obj, formatter.caseFalse);
    }
}
function dateFormat(_obj, formatter) {
    var keys = [];
    var date = getBaseDate(formatter);
    if (!date) {
        return { value: "", keys: keys };
    }
    if (formatter.plusYear) {
        date = (0, date_1.addDate)(date, formatter.plusYear, "year");
    }
    if (formatter.plusMonth) {
        date = (0, date_1.addDate)(date, formatter.plusMonth, "month");
    }
    if (formatter.plusDate) {
        date = (0, date_1.addDate)(date, formatter.plusDate, "date");
    }
    return { value: (0, moment_1.default)(date).format(formatter.format), keys: [] };
}
function getBaseDate(formatter) {
    var now = new Date();
    switch (formatter.value) {
        case "YEAR_START":
            return (0, date_1.normalizeDate)(now, "year");
        case "YEAR_END":
            return (0, date_1.addDate)((0, date_1.addDate)((0, date_1.normalizeDate)(now, "year"), 1, "year"), -1, "date");
        case "MONTH_START":
            return (0, date_1.normalizeDate)(now, "month");
        case "MONTH_END":
            return (0, date_1.addDate)((0, date_1.addDate)((0, date_1.normalizeDate)(now, "month"), 1, "month"), -1, "date");
        case "TODAY": {
            var now_1 = new Date();
            now_1.setTime(formatter.offset ? now_1.getTime() + Number(formatter.offset) : now_1.getTime());
            return (0, date_1.normalizeDate)(now_1, "date");
        }
    }
}
function isDateFormat(obj, formatter) {
    var value = formatWithKeys(obj, formatter.item);
    return { value: Array.isArray(value) ? value.every(function (v) { return (0, date_1.isDate)(v.value); }) : (0, date_1.isDate)(value.value), keys: [] };
}
function keyFormat(obj, formatter) {
    function t(v) {
        return {
            value: formatter.transform !== undefined ? transform(formatter.transform, v) : (0, object_1.getValueFromValueWithKey)(v),
            keys: (0, object_1.getKeysFromValueWithKey)(v),
        };
    }
    var valueWithKey = (0, object_1.getWithKey)(obj, formatter.key);
    if (Array.isArray(valueWithKey)) {
        return valueWithKey.map(function (v) { return t(v); });
    }
    else if ((0, object_1.isValueWithKeyRoot)(valueWithKey)) {
        return t(valueWithKey);
    }
    else {
        return Object.keys(valueWithKey)
            .sort(util_1.byAlphabetically)
            .map(function (key) { return t(valueWithKey[key]); });
    }
}
function replaceFormat(obj, formatter) {
    var pattern = formatter.regexp ? new RegExp(formatter.pattern, formatter.all ? "g" : undefined) : formatter.pattern;
    function t(v) {
        var _a;
        var original = ((_a = v.value) === null || _a === void 0 ? void 0 : _a.toString()) || "";
        if (formatter.all && !formatter.regexp) {
            return { value: original.replaceAll(pattern, formatter.replace), keys: v.keys };
        }
        else {
            return { value: original.replace(pattern, formatter.replace), keys: v.keys };
        }
    }
    var value = formatWithKeys(obj, formatter.value);
    return Array.isArray(value) ? value.map(function (v) { return t(v); }) : t(value);
}
function stringifyFormat(obj, formatter) {
    if (formatter.values.length === 0) {
        return { value: formatter.format, keys: [] };
    }
    var formatResults = formatter.values.map(function (fv) { return formatWithKeys(obj, fv); });
    var lens = formatResults.map(function (fr) {
        var v = getFormattedValues(fr);
        return Array.isArray(v) ? v.length : -1;
    });
    var maxLen = Math.max.apply(Math, __spreadArray([], __read(lens), false));
    if (maxLen === -1) {
        return {
            value: stringify(formatter.format, formatResults.map(function (fr) { return getFormattedValues(fr); })),
            keys: formatResults.reduce(function (prev, fr) { return prev.concat(getFormattedKeys(fr)); }, []),
        };
    }
    return (0, range_1.default)(maxLen).map(function (i) {
        var value = stringify(formatter.format, formatResults.map(function (fr) {
            var v = getFormattedValues(fr);
            if (!v) {
                return v;
            }
            else if ((0, date_1.isDate)(v)) {
                return new Date(v);
            }
            else if (Array.isArray(v)) {
                return v[i % v.length];
            }
            else if (typeof v === "object") {
                var keys_1 = Object.keys(v);
                return v[keys_1[i % keys_1.length]];
            }
            else {
                return v;
            }
        }));
        var keys = formatResults.reduce(function (prev, fr) { return prev.concat((Array.isArray(fr) ? fr[i % fr.length] : fr).keys); }, []);
        return { value: value, keys: keys };
    });
}
function splitFormat(obj, formatter) {
    function t(v) {
        var _a;
        var original = ((_a = v.value) === null || _a === void 0 ? void 0 : _a.toString()) || "";
        return {
            value: original.split(formatter.separator || exports.DEFAULT_CODE_SEPARATOR)[formatter.index || 0],
            keys: v.keys,
        };
    }
    var value = formatWithKeys(obj, formatter.value);
    return Array.isArray(value) ? value.map(function (v) { return t(v); }) : t(value);
}
function staticFormat(obj, formatter) {
    return { value: formatter.value, keys: [] };
}
function isTrue(result) {
    function check(res) {
        return res === true || res === "true" || res === 1 || res === "1";
    }
    return Array.isArray(result) ? result.every(function (r) { return check(r.value); }) : check(result.value);
}
function transform(format, valueWithKey) {
    var item = (0, object_1.getValueFromValueWithKey)(valueWithKey);
    if (item === null || item === undefined || item === "") {
        return item;
    }
    else if ((0, date_1.isDate)(item)) {
        return format ? (0, moment_1.default)(item).format(format) : JSON.parse(JSON.stringify(new Date(item)));
    }
    else if (typeof item === "object") {
        var inner = (0, object_1.get)(item, format);
        if (inner === null || inner === undefined || typeof inner === "string") {
            return inner;
        }
        else {
            return JSON.stringify(item);
        }
    }
    else {
        return (0, sprintf_js_1.sprintf)(format || "%s", item);
    }
}
function stringify(format, items) {
    var values = items.map(function (item) {
        if (item === null || item === undefined || item === "") {
            return "";
        }
        else if ((0, date_1.isDate)(item)) {
            return JSON.parse(JSON.stringify(item));
        }
        else if (typeof item === "object") {
            return JSON.stringify(item);
        }
        else {
            return item.toString();
        }
    });
    return sprintf_js_1.sprintf.apply(void 0, __spreadArray([format], __read(values), false));
}
function isFormatter(item) {
    if (!item || !("type" in item)) {
        return false;
    }
    switch (item.type) {
        case dto_1.FormatterType.COMPARE: {
            if (!("items" in item)) {
                return false;
            }
            var items = item.items;
            return Array.isArray(items) && items.length > 1 && items.every(function (i) { return isFormatter(i); });
        }
        case dto_1.FormatterType.CONDITION: {
            if (!("condition" in item) || !("caseTrue" in item) || !("caseFalse" in item)) {
                return false;
            }
            return isFormatter(item.condition) && isFormatter(item.caseTrue) && isFormatter(item.caseFalse);
        }
        case dto_1.FormatterType.DATE: {
            if (!("value" in item) || !("format" in item)) {
                return false;
            }
            else if (!dto_1.DateFormatterValues.includes(item.value)) {
                return false;
            }
            else if (typeof item.format !== "string") {
                return false;
            }
            else if ("plusYear" in item && typeof item.plusYear !== "number") {
                return false;
            }
            else if ("plusMonth" in item && typeof item.plusMonth !== "number") {
                return false;
            }
            else if ("plusDate" in item && typeof item.plusDate !== "number") {
                return false;
            }
            else {
                return true;
            }
        }
        case dto_1.FormatterType.IS_DATE: {
            if (!("item" in item)) {
                return false;
            }
            return isFormatter(item.item);
        }
        case dto_1.FormatterType.KEY: {
            if (!("key" in item)) {
                return false;
            }
            return ((typeof item.key === "string" && !("transform" in item)) ||
                item.transform === undefined ||
                typeof item.transform === "string");
        }
        case dto_1.FormatterType.SPLIT: {
            if (!("value" in item)) {
                return false;
            }
            var value = item.value, separator = item.separator, index = item.index;
            if (!isFormatter(value)) {
                return false;
            }
            if (separator !== undefined && typeof separator !== "string") {
                return false;
            }
            if (index !== undefined && typeof index !== "number") {
                return false;
            }
            return true;
        }
        case dto_1.FormatterType.REPLACE: {
            if (!("value" in item) || !("pattern" in item) || !("replace" in item)) {
                // pattern, replace, value は必須
                return false;
            }
            var value = item.value, pattern = item.pattern, replace = item.replace;
            if (!isFormatter(value)) {
                // value は Formatter じゃないとダメ
            }
            else if (typeof pattern !== "string" || typeof replace !== "string") {
                // pattern と replace は文字列じゃないとダメ
                return false;
            }
            if ("all" in item && typeof item.all !== "boolean") {
                // all は bool じゃないとダメ
                return false;
            }
            if (!("regexp" in item)) {
                // regexp がない場合、ここで終了
                return true;
            }
            if (typeof item.regexp !== "boolean") {
                // regexp は bool じゃないとダメ
                return false;
            }
            else if (!item.regexp) {
                // regexp が false の場合、ここで終了
                return true;
            }
            try {
                // regexp が true の場合 pattern は 正規表現として正しくないとダメ
                new RegExp(pattern);
                return true;
            }
            catch (e) {
                return false;
            }
        }
        case dto_1.FormatterType.STRINGIFY: {
            if (!("format" in item) || !("values" in item)) {
                return false;
            }
            var values = item.values;
            return typeof item.format === "string" && Array.isArray(values) && values.every(function (i) { return isFormatter(i); });
        }
        case dto_1.FormatterType.STATIC: {
            return true;
        }
        default:
            return false;
    }
}
exports.isFormatter = isFormatter;
function compareFormatter() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return { type: dto_1.FormatterType.COMPARE, items: items };
}
exports.compareFormatter = compareFormatter;
function conditionFormatter(condition, caseTrue, caseFalse) {
    return { type: dto_1.FormatterType.CONDITION, condition: condition, caseTrue: caseTrue, caseFalse: caseFalse };
}
exports.conditionFormatter = conditionFormatter;
function dateFormatter(value, format, option) {
    return {
        type: dto_1.FormatterType.DATE,
        value: value,
        format: format,
        plusYear: option === null || option === void 0 ? void 0 : option.plusYear,
        plusMonth: option === null || option === void 0 ? void 0 : option.plusMonth,
        plusDate: option === null || option === void 0 ? void 0 : option.plusDate,
    };
}
exports.dateFormatter = dateFormatter;
function isDateFormatter(item) {
    return { type: dto_1.FormatterType.IS_DATE, item: item };
}
exports.isDateFormatter = isDateFormatter;
function keyFormatter(key, transform) {
    return __assign({ type: dto_1.FormatterType.KEY, key: key }, (transform === undefined ? {} : { transform: transform }));
}
exports.keyFormatter = keyFormatter;
function replaceFormatter(value, pattern, replace, all, regexp) {
    return { type: dto_1.FormatterType.REPLACE, value: value, pattern: pattern, replace: replace, all: all, regexp: regexp };
}
exports.replaceFormatter = replaceFormatter;
function stringifyFormatter(format) {
    var values = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        values[_i - 1] = arguments[_i];
    }
    return { type: dto_1.FormatterType.STRINGIFY, format: format, values: values };
}
exports.stringifyFormatter = stringifyFormatter;
function staticFormatter(value) {
    return { type: dto_1.FormatterType.STATIC, value: value };
}
exports.staticFormatter = staticFormatter;
function splitFormatter(value, separator, index) {
    return { type: dto_1.FormatterType.SPLIT, value: value, separator: separator, index: index };
}
exports.splitFormatter = splitFormatter;
function defaultFormatter(key, defaultValue) {
    if (!key) {
        return staticFormatter(defaultValue);
    }
    else if (defaultValue === undefined) {
        return keyFormatter(key);
    }
    else {
        return conditionFormatter(compareFormatter(keyFormatter(key), staticFormatter(undefined)), staticFormatter(defaultValue), keyFormatter(key));
    }
}
exports.defaultFormatter = defaultFormatter;
var nonSimple = { isSimple: false };
function simpleExtract(formatter) {
    var transformFormat = formatter.type === dto_1.FormatterType.STRINGIFY ? formatter.format : undefined;
    var mainFormatter = formatter.type === dto_1.FormatterType.STRINGIFY ? formatter.values[0] : formatter;
    switch (mainFormatter.type) {
        case dto_1.FormatterType.CONDITION:
            if (mainFormatter.condition.type !== dto_1.FormatterType.COMPARE ||
                mainFormatter.caseFalse.type !== dto_1.FormatterType.KEY ||
                mainFormatter.caseTrue.type !== dto_1.FormatterType.STATIC) {
                return nonSimple;
            }
            return {
                isSimple: true,
                value: mainFormatter.caseFalse.key,
                defaultValue: mainFormatter.caseTrue.value,
                transformFormat: transformFormat,
            };
        case dto_1.FormatterType.KEY:
            return { isSimple: true, value: mainFormatter.key, transformFormat: mainFormatter.transform };
        case dto_1.FormatterType.STATIC:
            return typeof mainFormatter.value === "string"
                ? { isSimple: true, defaultValue: mainFormatter.value, transformFormat: transformFormat }
                : nonSimple;
        default: {
            return nonSimple;
        }
    }
}
exports.simpleExtract = simpleExtract;
function buildFromSimple(value, transformFormat, defaultValue) {
    if (!value) {
        return staticFormatter(defaultValue);
    }
    else if (!defaultValue) {
        return keyFormatter(value, transformFormat);
    }
    else {
        return conditionFormatter(compareFormatter(keyFormatter(value, transformFormat), staticFormatter(undefined)), staticFormatter(defaultValue), keyFormatter(value, transformFormat));
    }
}
exports.buildFromSimple = buildFromSimple;
function convert(result, type) {
    function c(_a, type) {
        var value = _a.value, keys = _a.keys;
        if (value === null || value === undefined) {
            return { value: value, keys: keys };
        }
        switch (type) {
            case enum_1.FormatType.NUMBER:
                return { value: formatNumber(value), keys: keys };
            case enum_1.FormatType.STRING:
                return { value: formatString(value), keys: keys };
            case enum_1.FormatType.DATE:
                return { value: formatDate(value), keys: keys };
            case enum_1.FormatType.BOOLEAN:
                return { value: formatBoolean(value), keys: keys };
            case enum_1.FormatType.NULL:
                return { value: null, keys: keys };
        }
    }
    return Array.isArray(result) ? result.map(function (r) { return c(r, type); }) : c(result, type);
}
exports.convert = convert;
function formatNumber(value) {
    if (typeof value === "number") {
        return value;
    }
    else if ((0, date_1.isDate)(value)) {
        return (0, moment_1.default)(value).toDate().getTime();
    }
    var num = Number(value);
    return isNaN(num) || value === "" ? null : num;
}
function formatString(value) {
    if ((0, date_1.isDate)(value)) {
        return formatDate(value);
    }
    else if (typeof value === "string") {
        return value;
    }
    else {
        return JSON.stringify(value);
    }
}
function formatDate(value) {
    if (value === null || value === undefined || typeof value === "string") {
        return value;
    }
    else if (value instanceof Date) {
        return JSON.parse(JSON.stringify(new Date(value)));
    }
    return null;
}
function formatBoolean(value) {
    return value === "1" || value === "true" || value === 1 || false;
}
var lang = "ja-JP";
var DEFAULT_CURRENCY = "JPY";
function money(value, currency) {
    try {
        var moneyFormatter = new Intl.NumberFormat(lang, {
            style: "currency",
            currency: currency || DEFAULT_CURRENCY,
        });
        return value === null || value === "" || typeof value === "undefined"
            ? undefined
            : moneyFormatter.format(Number(value));
    }
    catch (_a) {
        return value;
    }
}
exports.money = money;
